const DIVISIONS: Array<{ amount: number; name: Intl.RelativeTimeFormatUnit }> = [
   { amount: 7, name: 'days' },
   { amount: 4.345_24, name: 'weeks' },
   { amount: 12, name: 'months' },
   { amount: Number.POSITIVE_INFINITY, name: 'years' },
];

/**
 * Formats a date relative to now using natural language:
 * "yesterday", "2 days ago", "3 weeks ago", "2 months ago", etc.
 */
export function formatRelativeDate(date: Date, locale: string = 'en'): string {
   const formatter = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' });
   const normalizedDate = new Date(date);
   normalizedDate.setHours(0, 0, 0, 0);
   const today = new Date();
   today.setHours(0, 0, 0, 0);
   let duration = (normalizedDate.getTime() - today.getTime()) / 1000 / 60 / 60 / 24;

   for (const division of DIVISIONS) {
      if (Math.abs(duration) < division.amount) {
         return formatter.format(Math.round(duration), division.name);
      }
      duration /= division.amount;
   }
   return date.toLocaleDateString(locale);
}
